var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLeave = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.635,
    height: 32,
    viewBox: "0 0 24.635 27.662",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#262e45",
    d: "M15.826.242l.1 12.61a1.429 1.429 0 0 1-2.857 0l-.1-12.61-1.6 1.6a1.43 1.43 0 0 1-2.023-2.02l4.041-4.039a1.429 1.429 0 0 1 2.02 0l4.041 4.04a1.43 1.43 0 0 1-2.023 2.021zm-14.4 16.9h24.8a1.429 1.429 0 1 1 0 2.857H1.429a1.429 1.429 0 1 1 0-2.857z",
    transform: "rotate(90 10 10)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLeave);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/leave.0dfd802623c5e81d55ef308c01f14fc2.svg";